"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatusDescription = exports.getStatusIcon = exports.getIssuerStatus = exports.formatDate = void 0;
const constants_1 = require("../../../constants/constants");
const verified_icon_svg_1 = __importDefault(require("../../../assets/images/icons/verified-icon.svg"));
const pending_icon_svg_1 = __importDefault(require("../../../assets/images/icons/pending-icon.svg"));
const not_verified_icon_svg_1 = __importDefault(require("../../../assets/images/icons/not-verified-icon.svg"));
const formatDate = (date, separator) => {
    const newDate = new Date(date);
    let day = newDate.getDate();
    let month = newDate.getUTCMonth() + 1;
    let year = newDate.getFullYear();
    let dateArr = [day, month, year];
    return dateArr.join(separator);
};
exports.formatDate = formatDate;
const getIssuerStatus = (item) => {
    return constants_1.IssuerStatuses[item
        ? "velocityCredential" in item &&
            item.velocityCredential &&
            item.velocityCredential.recordStatus === 2
            ? 0
            : item.expireDate
                ? new Date(item.expireDate) > new Date()
                    ? 1
                    : 0
                : 1
        : 1];
};
exports.getIssuerStatus = getIssuerStatus;
const getStatusIcon = (item) => {
    switch ((0, exports.getIssuerStatus)(item)) {
        case "verified":
            return verified_icon_svg_1.default;
        case "pending":
            return pending_icon_svg_1.default;
        default:
            return not_verified_icon_svg_1.default;
    }
};
exports.getStatusIcon = getStatusIcon;
const getStatusDescription = (item, translate) => {
    return item
        ? "velocityCredential" in item &&
            item.velocityCredential &&
            item.velocityCredential.recordStatus === 2
            ? translate("revoked")
            : "offerExpirationDate" in item
                ? translate("noExpire")
                : item.expireDate
                    ? new Date(item.expireDate) > new Date()
                        ? translate("valid", {
                            expireDate: (0, exports.formatDate)(item.expireDate, "/"),
                        })
                        : translate("expired")
                    : translate("noExpire")
        : "";
};
exports.getStatusDescription = getStatusDescription;
